module.exports = __webpack_public_path__ + "static/media/logo.bfa345dc.png";